/** Compteur d’ops IMAP exclusives côté client (corps, PJ, brouillon) — évite sync live concurrente. */
let exclusiveOps = 0;

export function isImapClientBusy(): boolean {
  return exclusiveOps > 0;
}

/** À appeler dans un finally — libère le verrou même en cas d’erreur. */
export function releaseImapExclusiveOp(): void {
  exclusiveOps = Math.max(0, exclusiveOps - 1);
}

export function beginImapExclusiveOp(): void {
  exclusiveOps += 1;
}

export async function withImapExclusiveOp<T>(fn: () => Promise<T>): Promise<T> {
  beginImapExclusiveOp();
  try {
    return await fn();
  } finally {
    releaseImapExclusiveOp();
  }
}
